import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import YouTubeCallback from "@/components/YouTubeCallback.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/room",
    name: "Room Screen",
    component: () => import("@/components/RoomScreen.vue")
  },
  {
    path: "/clerk",
    name: "Clerk Screen",
    component: () => import("@/components/ClerkScreen.vue")
  },
  {
    path: "/online-bidding",
    name: "Online Bidding Screen",
    component: () => import("@/components/OnlineBiddingScreen.vue")
  },
  {
    path: "/auctioneer",
    name: "Auctioneer Screen",
    component: () => import("@/components/AuctioneerScreen.vue")
  },
  {
    path: "/stream",
    name: "Streamer",
    component: () => import("@/components/shared/StreamerModule.vue")
  },
  {
    path: "/stream-v2",
    name: "Stream Screen",
    component: () => import("@/components/shared/StreamerV2Module.vue")
  },
  {
    path: "/thank-you",
    name: "Thank you Screen",
    component: () => import("@/components/ThankYouScreen.vue")
  },
  {
    path: "/welcome",
    name: "Welcome Screen",
    component: () => import("@/components/WelcomeScreen.vue")
  },
  {
    path: "/pause",
    name: "Pause Screen",
    component: () => import("@/components/PauseScreen.vue")
  },
  {
    path: '/youtube/callback',
    name: 'YouTubeCallback',
    component: YouTubeCallback,
    props: route => ({ code: route.query.code, state: route.query.state })
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
